export default "__VITE_ASSET__BbMr$aUA__"